module.exports = __webpack_public_path__ + "static/media/snake.1076da64.jpg";